<template lang="pug">
.m-2
  b.pr-2
    | {{ link.numeroTOL }}
  a(
    target="_blank"
    :href="url_for_rails_documento_show(link.id)"
  )
    | {{ link.title }}
</template>

<script>
import mixins from 'common/mixins'

export default {
  name: 'link-vue',
  props: {
    link: { type: Object, default: {} }
  },
  mixins: [mixins.requests]
}
</script>
